import Component from './OnboardingPage';
import Container from './OnboardingPage.container';

export default Container(Component);
